import {
  PURCHASE_ORDER_LIST_GET_REQUEST,
  PURCHASE_ORDER_LIST_GET_SUCCESS,
  PURCHASE_ORDER_LIST_GET_FAILURE,
  PURCHASE_ORDER_SEARCH_REQUEST,
  PURCHASE_ORDER_SEARCH_SUCCESS,
  PURCHASE_ORDER_SEARCH_FAILURE,
  PURCHASE_ORDER_DATA_REQUEST,
  PURCHASE_ORDER_DATA_SUCCESS,
  PURCHASE_ORDER_DATA_FAILURE,
  PURCHASE_ORDER_CREATE_REQUEST,
  PURCHASE_ORDER_CREATE_SUCCESS,
  PURCHASE_ORDER_CREATE_FAILURE,
  PURCHASE_ORDER_UPDATE_REQUEST,
  PURCHASE_ORDER_UPDATE_SUCCESS,
  PURCHASE_ORDER_UPDATE_FAILURE,
  PURCHASE_ORDER_VOID_REQUEST,
  PURCHASE_ORDER_VOID_SUCCESS,
  PURCHASE_ORDER_VOID_FAILURE,
  PURCHASE_ORDER_MARK_COMPLETE_REQUEST,
  PURCHASE_ORDER_MARK_COMPLETE_SUCCESS,
  PURCHASE_ORDER_MARK_COMPLETE_FAILURE,
  PURCHASE_ORDER_STATUS_LIST_GET_REQUEST,
  PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS,
  PURCHASE_ORDER_STATUS_LIST_GET_FAILURE,
  PURCHASE_ORDER_STATUS_DATA_REQUEST,
  PURCHASE_ORDER_STATUS_DATA_SUCCESS,
  PURCHASE_ORDER_STATUS_DATA_FAILURE,
  PURCHASE_ORDER_STATUS_CREATE_REQUEST,
  PURCHASE_ORDER_STATUS_CREATE_SUCCESS,
  PURCHASE_ORDER_STATUS_CREATE_FAILURE,
  PURCHASE_ORDER_STATUS_UPDATE_REQUEST,
  PURCHASE_ORDER_STATUS_UPDATE_SUCCESS,
  PURCHASE_ORDER_STATUS_UPDATE_FAILURE,
  PURCHASE_ORDER_STATUS_DELETE_REQUEST,
  PURCHASE_ORDER_STATUS_DELETE_SUCCESS,
  PURCHASE_ORDER_STATUS_DELETE_FAILURE,
  PURCHASE_ORDER_PDF_REQUEST,
  PURCHASE_ORDER_PDF_SUCCESS,
  PURCHASE_ORDER_PDF_FAILURE,
} from "./actionType";

//PURCHASE_ORDER_LIST_GET_REQUEST
export const purchaseOrderListGetRequest = () => {
  return {
    type: PURCHASE_ORDER_LIST_GET_REQUEST,
  };
};
//PURCHASE_ORDER_LIST_GET_SUCCESS
export const purchaseOrderListGetSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_LIST_GET_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_LIST_GET_FAILURE
export const purchaseOrderListGetFailure = (error) => {
  return {
    type: PURCHASE_ORDER_LIST_GET_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_SEARCH_REQUEST
export const purchaseOrderSearchRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_SEARCH_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_SEARCH_SUCCESS
export const purchaseOrderSearchSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_SEARCH_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_SEARCH_FAILURE
export const purchaseOrderSearchFailure = (error) => {
  return {
    type: PURCHASE_ORDER_SEARCH_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_DATA_REQUEST
export const purchaseOrderDataRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_DATA_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_DATA_SUCCESS
export const purchaseOrderDataSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_DATA_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_DATA_FAILURE
export const purchaseOrderDataFailure = (error) => {
  return {
    type: PURCHASE_ORDER_DATA_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_CREATE_REQUEST
export const purchaseOrderCreateRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_CREATE_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_CREATE_SUCCESS
export const purchaseOrderCreateSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_CREATE_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_CREATE_FAILURE
export const purchaseOrderCreateFailure = (error) => {
  return {
    type: PURCHASE_ORDER_CREATE_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_UPDATE_REQUEST
export const purchaseOrderUpdateRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_UPDATE_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_UPDATE_SUCCESS
export const purchaseOrderUpdateSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_UPDATE_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_UPDATE_FAILURE
export const purchaseOrderUpdateFailure = (error) => {
  return {
    type: PURCHASE_ORDER_UPDATE_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_VOID_REQUEST
export const purchaseOrderVoidRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_VOID_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_VOID_SUCCESS
export const purchaseOrderVoidSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_VOID_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_VOID_FAILURE
export const purchaseOrderVoidFailure = (error) => {
  return {
    type: PURCHASE_ORDER_VOID_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_MARK_COMPLETE_REQUEST
export const purchaseOrderMarkCompleteRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_MARK_COMPLETE_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_MARK_COMPLETE_SUCCESS
export const purchaseOrderMarkCompleteSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_MARK_COMPLETE_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_MARK_COMPLETE_FAILURE
export const purchaseOrderMarkCompleteFailure = (error) => {
  return {
    type: PURCHASE_ORDER_MARK_COMPLETE_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_STATUS_LIST_GET_REQUEST
export const purchaseOrderStatusListGetRequest = () => {
  return {
    type: PURCHASE_ORDER_STATUS_LIST_GET_REQUEST,
  };
};

//PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS
export const purchaseOrderStatusListGetSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_LIST_GET_FAILURE
export const purchaseOrderStatusListGetFailure = (error) => {
  return {
    type: PURCHASE_ORDER_STATUS_LIST_GET_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_STATUS_DATA_REQUEST
export const purchaseOrderStatusDataRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_DATA_REQUEST,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_DATA_SUCCESS
export const purchaseOrderStatusDataSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_DATA_SUCCESS,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_DATA_FAILURE
export const purchaseOrderStatusDataFailure = (error) => {
  return {
    type: PURCHASE_ORDER_STATUS_DATA_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_STATUS_CREATE_REQUEST
export const purchaseOrderStatusCreateRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_CREATE_REQUEST,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_CREATE_SUCCESS
export const purchaseOrderStatusCreateSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_CREATE_SUCCESS,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_CREATE_FAILURE
export const purchaseOrderStatusCreateFailure = (error) => {
  return {
    type: PURCHASE_ORDER_STATUS_CREATE_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_STATUS_UPDATE_REQUEST
export const purchaseOrderStatusUpdateRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_UPDATE_REQUEST,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_UPDATE_SUCCESS
export const purchaseOrderStatusUpdateSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_UPDATE_SUCCESS,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_UPDATE_FAILURE
export const purchaseOrderStatusUpdateFailure = (error) => {
  return {
    type: PURCHASE_ORDER_STATUS_UPDATE_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_STATUS_DELETE_REQUEST
export const purchaseOrderStatusDeleteRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_DELETE_REQUEST,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_DELETE_SUCCESS
export const purchaseOrderStatusDeleteSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_STATUS_DELETE_SUCCESS,
    payload,
  };
};

//PURCHASE_ORDER_STATUS_DELETE_FAILURE
export const purchaseOrderStatusDeleteFailure = (error) => {
  return {
    type: PURCHASE_ORDER_STATUS_DELETE_FAILURE,
    error,
  };
};

//PURCHASE_ORDER_PDF_REQUEST
export const purchaseOrderPdfRequest = (payload) => {
  return {
    type: PURCHASE_ORDER_PDF_REQUEST,
    payload,
  };
};
//PURCHASE_ORDER_PDF_SUCCESS
export const purchaseOrderPdfSuccess = (payload) => {
  return {
    type: PURCHASE_ORDER_PDF_SUCCESS,
    payload,
  };
};
//PURCHASE_ORDER_PDF_FAILURE
export const purchaseOrderPdfFailure = (error) => {
  return {
    type: PURCHASE_ORDER_PDF_FAILURE,
    error,
  };
};
